module.exports = __webpack_public_path__ + "44f561aea2858d09836e5e43509c1a5f.svg";